var paragraph_default = {
  "fontElementMap": "LqqS8",
  "elementSpacing": "-MEVt",
  "text": "CXq4- -MEVt",
  "child": "mRJYz"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
